/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SignupStep } from './';
import {
    SignupStepFromJSON,
    SignupStepFromJSONTyped,
    SignupStepToJSON,
} from './';

/**
 * 
 * @export
 * @interface StepEmailAwaitingValidation
 */
export interface StepEmailAwaitingValidation extends SignupStep {
    /**
     * The email address provided by the user
     * @type {string}
     * @memberof StepEmailAwaitingValidation
     */
    email: string;
}

/**
 * Check if a given object implements the StepEmailAwaitingValidation interface.
 */
export function instanceOfStepEmailAwaitingValidation(value: object): value is StepEmailAwaitingValidation {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function StepEmailAwaitingValidationFromJSON(json: any): StepEmailAwaitingValidation {
    return StepEmailAwaitingValidationFromJSONTyped(json, false);
}

export function StepEmailAwaitingValidationFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepEmailAwaitingValidation {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepFromJSONTyped(json, ignoreDiscriminator),
        'email': json['email'],
    };
}

export function StepEmailAwaitingValidationToJSON(value?: StepEmailAwaitingValidation | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepToJSON(value, true),
        'email': value['email'],
    };
}

